import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=5fc36787"
import script from "./LeftMenu.ts?vue&type=script&lang=js&external"
export * from "./LeftMenu.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports